import React, {useEffect, useState} from 'react';
import SubMenu from "./SubMenu";


export default function DropDown(props) {
    const [open , setOpen] = useState(false)
    const openSubMenu = () => {
        setOpen(!open)
    }

    return (
       <div className="drop-down d-flex align-items-center">
           <div onClick={openSubMenu} className={`input d-flex justify-content-between align-items-center ${open && 'input-active'}`}>
               <p className="mt-0 blue-navy ">Authors Table</p>
               <svg style={open ? {transform:'rotate(-90deg)'}:{}} xmlns="http://www.w3.org/2000/svg" width="7.427" height="12.732" viewBox="0 0 7.427 12.732">
                   <g id="ArrowDown" transform="rotate(-90 21.366 399.305)">
                       <path id="Line_19" d="M0 5.305L5.305 0" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1" transform="rotate(-90 396.653 -12.348)"/>
                       <path id="Line_20" d="M0 0L5.305 5.305" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1" transform="rotate(-90 399.305 -15)"/>
                   </g>
               </svg>
           </div>
           {open && <SubMenu selectTable={props.selectTable} table={props.table} />}
       </div>
    );
}
